var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from 'root/src/client/v2/common/helpers/cn';
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverContent = forwardRef((_a, ref) => {
    var { className, align = 'center', sideOffset = 6 } = _a, props = __rest(_a, ["className", "align", "sideOffset"]);
    return (<PopoverPrimitive.Portal>
		<PopoverPrimitive.Content ref={ref} align={align} sideOffset={sideOffset} className={cn('redesign z-[1102] w-64 origin-[var(--radix-popover-content-transform-origin)] rounded-xl border border-solid border-border bg-popover p-3 text-popover-foreground shadow-xl shadow-black/40 outline-none', 'data-[state=open]:animate-tooltip-in data-[state=closed]:animate-tooltip-out', className)} {...props}/>
	</PopoverPrimitive.Portal>);
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
